import script from "./HeroHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeroHeader.vue?vue&type=script&lang=ts&setup=true"

import "./HeroHeader.vue?vue&type=style&index=0&id=cbb4f542&lang=css"

const __exports__ = script;

export default __exports__